<div class="role6-120200-form-container">
  <p-toast></p-toast>
  <app-sheet-loader [visible]="isLoading" />

  <p-card [header]="formTitle" [subheader]="isDev ? '[120200] Disclosure - Directors business review' : ''" *ngIf="!isLoading && schema && businessReviewForm" class="form-card">

    <form [formGroup]="businessReviewForm">
      <!-- Dynamic Fields and Section Headers -->
      <ng-container *ngFor="let control of schema.controls">
        <!-- Section Header -->
        <div *ngIf="control.ui.control === 'section-header'" class="bg-gray-200 text-black-700 text-sm font-medium px-2 py-1 mt-3">
          {{ control.label }}
        </div>

        <!-- Form Fields -->
        <div class="form-field" *ngIf="control.ui.control !== 'section-header' && shouldShowField(control)">
          <label class="field-label" [class.required]="isFieldRequired(control)">
            {{ control.label }}<app-required-marker [when]="isFieldRequired(control)" />
            <!-- <span class="warning-mark" *ngIf="hasWarnings(control.qname)">*</span> -->
          </label>

          <!-- Text Input -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'text'">
            <input
              type="text"
              pInputText
              [formControlName]="control.qname"
              [placeholder]="control | placeholder"
              class="w-full"
              [class.p-invalid]="getControl(control.qname)?.invalid && getControl(control.qname)?.touched"
              [maxlength]="getMaxLength(control.qname)"
              [pKeyFilter]="shouldBeNumericOnly(control.qname) ? 'num' : null"
            />

            <!-- Error Messages (Multiple) -->
            <div *ngIf="hasError(control.qname)" class="error-messages">
              <div *ngFor="let errorMsg of getAllErrorMessages(control.qname)" class="error-message" [innerHTML]="errorMsg"></div>
            </div>

            <!-- Warning messages -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

          <!-- Rich-text (WYSIWYG) field — same preview + pop-out editor as role
               750000 (AS-897). type: TextBlock, required. Value stays a plain
               HTML string; required parity holds because the field normalizes
               empty content to '', which Validators.required treats as empty. -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'richtext'">
            <app-rich-text-field
              [formControlName]="control.qname"
              [title]="control.label"
              [placeholder]="control | placeholder: 'Click to add content…'"
              [invalid]="!!(getControl(control.qname)?.invalid && getControl(control.qname)?.touched)"
            ></app-rich-text-field>

            <!-- Error Messages (Multiple) -->
            <div *ngIf="hasError(control.qname)" class="error-messages">
              <div *ngFor="let errorMsg of getAllErrorMessages(control.qname)" class="error-message" [innerHTML]="errorMsg"></div>
            </div>

            <!-- Warning messages -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

          <!-- Select/Dropdown -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'select'">
            <p-select
              [formControlName]="control.qname"
              [options]="getDropdownOptions(control.ui.enumSource)"
              optionLabel="label"
              optionValue="value"
              [placeholder]="control | placeholder: 'Please select'"
              class="w-full"
              [filter]="true"
              filterPlaceholder="Search..."
              [class.p-invalid]="getControl(control.qname)?.invalid && getControl(control.qname)?.touched"
              [showClear]="true"
            ></p-select>

            <!-- Error Messages (Multiple) -->
            <div *ngIf="hasError(control.qname)" class="error-messages">
              <div *ngFor="let errorMsg of getAllErrorMessages(control.qname)" class="error-message" [innerHTML]="errorMsg"></div>
            </div>

            <!-- Warning messages -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

          <!-- Number Input -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'number'">
            <!-- Schema-driven numeric constraints (min/max/decimals/grouping) via
                 appSchemaNumeric — see role23-740000-notes-issued-capital for the
                 established pattern. Do NOT bind [min]/[max] here; see this
                 folder's CLAUDE.md "Numeric sheet fields" callout. -->
            <p-inputnumber
              appSchemaNumeric
              appNegativeHighlight
              [schemaControl]="control"
              [formControlName]="control.qname"
              [placeholder]="control | placeholder"
              [minFractionDigits]="numericPolicy(control).decimals"
              [maxFractionDigits]="numericPolicy(control).decimals"
              [useGrouping]="numericPolicy(control).grouping"
              class="w-full"
              [class.p-invalid]="getControl(control.qname)?.invalid && getControl(control.qname)?.touched"
            ></p-inputnumber>

            <!-- Error Messages (Multiple) -->
            <div *ngIf="hasError(control.qname)" class="error-messages">
              <div *ngFor="let errorMsg of getAllErrorMessages(control.qname)" class="error-message" [innerHTML]="errorMsg"></div>
            </div>

            <!-- Warning messages -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>
        </div>
      </ng-container>
    </form>

    <!-- Form Status -->
    <!-- <div *ngIf="!isLoading && schema && businessReviewForm" class="form-status mt-4">
      <p>
        <strong>Form Status:</strong>
        <span [class]="businessReviewForm.valid ? 'text-green-600' : 'text-red-600'">
          {{ businessReviewForm.valid ? 'Valid ✓' : 'Invalid - Please fill required fields' }}
        </span>
      </p>
      <p>
        <strong>Total Fields:</strong> {{ schema.controls.length || 0 }}
      </p>
      <p>
        <strong>Auto-save:</strong>
        <span class="text-green-600">Enabled (500ms debounce)</span>
      </p>
    </div> -->
    <submit-for-validation
      [form]="businessReviewForm"
      [sheetKey]="'directorBusinessReview'"
      [formTitle]="formTitle"
      [visibleFormData]="getVisibleFormData()"
      (cancelConfirmed)="onCancelConfirmed()"
    ></submit-for-validation>
  </p-card>
</div>
